import { AppStore } from "@/store";
import type Dexie from "dexie";
import type { Table, TransactionMode } from "dexie";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
class BaseRepository<TEntity, TKey = number> {
  constructor() {}
}

export class BaseSyncModelRepository<TRecord, _TEntity, TKey = number> extends BaseRepository<
  TRecord,
  TKey
> {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  constructor({ store }: { store: AppStore }) {
    super();
  }
}

export class BaseDexieRepository<TEntity, TKey = number> extends BaseRepository<TEntity, TKey> {
  protected readonly tableRef: () => Table<TEntity, TKey>;

  constructor({ tableRef }: { tableRef: () => Table<TEntity, TKey> }) {
    super();
    this.tableRef = tableRef;
  }

  get table(): Table<TEntity, TKey> {
    return this.tableRef();
  }

  get db(): Dexie {
    return this.table.db;
  }

  public get dexieTable(): Table<TEntity, TKey> {
    return this.table;
  }

  protected transaction<TResult>(
    mode: TransactionMode,
    scope: () => Promise<TResult> | TResult,
    extraTables: Array<Table<unknown, unknown, unknown>> = []
  ): Promise<TResult> {
    const primaryTable = this.table as unknown as Table<unknown, unknown, unknown>;
    const tables = [primaryTable, ...extraTables];

    type TransactionRunner = (
      transactionMode: TransactionMode,
      ...transactionArgs: Array<
        Table<unknown, unknown, unknown> | (() => Promise<TResult> | TResult)
      >
    ) => Promise<TResult>;

    const runTransaction = this.db.transaction.bind(this.db) as TransactionRunner;

    return runTransaction(mode, ...tables, scope);
  }

  async clearAll(): Promise<void> {
    await this.table.clear();
  }
}
